/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Debt_Due_Date_InvalidInputs */

const en_case_validation_debt_due_date_invalid = /** @type {(inputs: Case_Validation_Debt_Due_Date_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid due date.`)
};

const pt_br2_case_validation_debt_due_date_invalid = /** @type {(inputs: Case_Validation_Debt_Due_Date_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe uma data de vencimento válida.`)
};

/**
* | output |
* | --- |
* | "Enter a valid due date." |
*
* @param {Case_Validation_Debt_Due_Date_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_debt_due_date_invalid = /** @type {((inputs?: Case_Validation_Debt_Due_Date_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Debt_Due_Date_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_debt_due_date_invalid(inputs)
	return pt_br2_case_validation_debt_due_date_invalid(inputs)
});